import type { RouteObject } from 'react-router-dom'

import { Component as Dashboard } from '@/modules/employer/pages/Dashboard'
import { EmployerRoutePathsEnum } from '@/modules/employer/routes/employerRouteConfig.types'

export const EMPLOYER_ROUTES: RouteObject[] = [
  {
    element: <Dashboard />,
    path: EmployerRoutePathsEnum.DASHBOARD,
  },
]
